module.exports = __webpack_public_path__ + "img/selected3-min.0a3a71a1.png";